class HomeStateClass {
    constructor() {
        this.tab = 'clients'
    }
}

let homeState = new HomeStateClass();

let state = {
    homeState: homeState
}

export default state;
export let HomeState = homeState;